import './GradientText.css';

const GradientText = ({
  children,
  className = '',
  style = {},
  from = '#E11D2E',
  to = '#FFFFFF',
  angle = 90,
  as: Tag = 'span',
}) => {
  const inlineStyles = {
    '--gradient-from': from,
    '--gradient-to': to,
    '--gradient-angle': `${angle}deg`,
    ...style,
  };

  return (
    <Tag className={`gradient-text ${className}`} style={inlineStyles}>
      {children}
    </Tag>
  );
};

export default GradientText;
